import {useContext} from 'react';
import {FormContext} from 'store/Form';

function useForm() {
    return useContext(FormContext);
}

export default useForm;
